import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=ee1dd338&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"
import style0 from "./message-list.vue?vue&type=style&index=0&id=ee1dd338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1dd338",
  null
  
)

export default component.exports